export default defineAppConfig({
  ui: {
    primary: 'custom-primary',
  },
})
